import Trinity from '@core/scripts/components/trinity-adapter.js';
import Device from '@core/scripts/components/device.js';
import {ClickEventAttributes, CommonEventAttributes, HoverEventAttributes} from './interfaces/EventAttributes';
import {EventObjectType} from '@checkout/components/tracking/model/EventObjectType';

export const TrinityEvents = {
    createAndSendTrinityEvent: (version: number, eventName: String, eventAttributes: CommonEventAttributes) => {
        const attributes = getAttributes(eventAttributes);
        const schema = {
            version: version,
            name: eventName
        };
        Trinity.sendTrinityEvent({ schema, attributes });
    },

    getClickAttributes: (clickName: string, page: string, eventObjectType: EventObjectType) : ClickEventAttributes => {
        return {
            clickName: clickName,
            page: page,
            object: eventObjectType
        };
    },

    getHoverAttributes: (hoverName: string, page: string, eventObjectType: EventObjectType) : HoverEventAttributes => {
        return {
            hoverName: hoverName,
            page: page,
            object: eventObjectType
        };
    }
}

const getAttributes = (commonEventAttributes: CommonEventAttributes) => {
    return {
        ...commonEventAttributes,
        isApp: Device.isApp() as boolean,
    }
}
